// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"d078e60f","337":"70d0de73","384":"716c36c9","571":"80c1d255","662":"47382c08","838":"25f96048"}[chunkId] + ".chunk.js";
};